import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import api from '../services/api';

const ReloadPermissions = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [hasExecuted, setHasExecuted] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (hasExecuted) return;
    
    const reloadUserPermissions = async () => {
      setHasExecuted(true);
      
      try {
        toast.info('Refreshing permissions...');
        
        // Get current user ID from localStorage
        const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
        const userId = currentUser.user_id;
        
        if (!userId) {
          throw new Error('No user ID found');
        }
        
        const response = await api.get(`/api/users/${userId}`);
        const result = response.data;
        
        if (result && result.status === 1 && result.data) {
          let rawUser = result.data;
          
          // Handle nested data structure
          if (rawUser.row) {
            rawUser = rawUser.row;
          }
          
          // Convert raw database row to proper user object
          const freshUser = {
            user_id: rawUser[0] || rawUser.user_id,
            user_email: rawUser[1] || rawUser.user_email,
            user_password: rawUser[2] || rawUser.user_password,
            user_full_name: rawUser[3] || rawUser.user_full_name,
            department: rawUser[4] || rawUser.department,
            user_image: rawUser[5] || rawUser.user_image,
            user_auth: rawUser[6] || rawUser.user_auth,
            user_phone: rawUser[7] || rawUser.user_phone,
            role: rawUser[8] || rawUser.role,
            supervisor: rawUser[9] || rawUser.supervisor,
            manager: rawUser[10] || rawUser.manager,
            hod: rawUser[11] || rawUser.hod,
            director: rawUser[12] || rawUser.director,
            approver: rawUser[13] || rawUser.approver,
            permissions: rawUser[14] || rawUser.permissions,
            department_id: rawUser[15] || rawUser.department_id,
            role_name: rawUser[16] || rawUser.role_name
          };
          
          // Always update localStorage with fresh data
          localStorage.setItem('user', JSON.stringify(freshUser));
          
          toast.success('Permissions refreshed successfully!');
          
          // Redirect to dashboard with page reload to ensure all components refresh
          setTimeout(() => {
            window.location.href = '/dashboard';
          }, 1000);
        } else {
          console.error('Invalid response:', result);
          toast.error('Failed to refresh permissions');
          setIsComplete(true);
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('Failed to refresh permissions');
        setIsComplete(true);
      }
    };

    reloadUserPermissions();
  }, [hasExecuted, navigate, updateUser]);

  if (isComplete) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center p-8">
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Complete</h2>
          <p className="text-gray-500 mb-4">Check console for details</p>
          <button 
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center p-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">Refreshing Permissions</h2>
        <p className="text-gray-500">Please wait while we update your access permissions...</p>
      </div>
    </div>
  );
};

export default ReloadPermissions;